import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { ServerSide500, Small404 } from "../../../constant/imagePath";
import Colors from "../../../stories/assets/Colors";
import Fonts from "../../../stories/assets/Fonts";
import { Button } from "../../../stories/Button/Button";
import { MobileHeader } from "../../../stories/MobileHeader/MobileHeader";
import classes from "./ServiceSideMaintenanceMobile.module.css";

export default function ServerSideMaintenanceMobile() {
  const history = useHistory();
  return (
    <div className={classes.serverSidePage}>
      <Container fluid className={` ${classes.container}`}>
        <MobileHeader
          isLogo={true}
          isAvatar={true}
          customStyle={{ padding: "0px" }}
        />
        <Row className="g-0">
          <Col md={12}>
            <div className={classes.img}>
              <img src={ServerSide500} />
            </div>
          </Col>
          <Col md={12}>
            <div className={classes.contentCenter}>
              <h3
                style={{
                  ...Fonts.h3,
                  fontSize: "24px",
                  lineHeight: "32px",
                  color: Colors.neutralShadesOfNero,
                }}
              >
                Internal server error
              </h3>
              <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>
                There is a problem with the resource you are looking for, and it
                cannot be displayed
              </p>
              <Button
                label={"Back to homepage"}
                size={"Large"}
                customStyle={{ marginTop: "32px", height: "56px" }}
                onClick={() => history.push("/")}
                primary={true}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
